import { SignInState } from 'src/app/sign-in/sign-in.component';
import { ApiUpdatePatientNameResponse, UpdatePatientForm } from '../../models';

export class FetchPreviewPatient {
  static readonly type = '[Patient] Fetch Preview Patient';
  constructor(public patientId: number) {}
}

export class GetPatients {
  static readonly type = '[Patient] Get Patients';
  constructor(public ipAddress: string, public lastSelectedPatientId: number | null) {}
}

export class LoadPatientData {
  static readonly type = '[Patient] Load/Preload Patient Data';
}

export class LoginPatient {
  static readonly type = '[Patient] Login Patient';
  constructor(public ipAddress: string, public patientId: number) {}
}

export class SetPatientConsent {
  static readonly type = '[Patient] Set Patient Consent';

  constructor(public patientId: number, public consentedToMarketing: boolean) {}
}

export class SetLastSelectedPatientId {
  static readonly type = '[User] Update Last Selected Patient ID';
  constructor(public patientId: number) {}
}

export class SetPatientIsLoading {
  static readonly type = '[Patient] Set Patient Is Loading';

  constructor(public values: boolean) {}
}

export class SetPatientName {
  static readonly type = '[Patient] Set Patient Name';

  constructor(public data: ApiUpdatePatientNameResponse) {}
}

export class SetSelectedPatientId {
  static readonly type = '[User] Update Selected Patient ID';
  constructor(public patientId: number) {}
}

export class UpdatePatient {
  static readonly type = '[Patient] Update Patient';

  constructor(
    public formValues: UpdatePatientForm,
    public options: { optimisticUpdate: boolean } = { optimisticUpdate: true }
  ) {}
}

export class SetPreferredLogin {
  static readonly type = '[Patient] Get Preferred Login';
  constructor(public preferredLogin: SignInState) {}
}

export class SetPreferredCodeMethod {
  static readonly type = '[Patient] Get Preferred Code Method';
  constructor(public preferredCodeMethod: 'email' | 'phone') {}
}
